export default __webpack_public_path__ + "static/media/Acubis-5-ban.a159c539.jpg";